import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';

import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-hr-academy',
  imports: [HeaderLatestComponent, PeopleflowFooterComponent],
  templateUrl: './hr-academy.html',
  styleUrl: './hr-academy.scss',
})
export class HrAcademy {

}
